import { Clock } from "lucide-react";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import MainLayout from "@/components/layouts";

export default function PendingPage() {
    const breadcrumb = [
        { name: "Pending Approval", href: "#" }
    ];

    return (
        <MainLayout breadcrumb={breadcrumb} rightSidebar={false}>
            <Card className="max-w-md mx-auto mt-32 text-center">
                <CardHeader>
                    <Clock className="mx-auto mb-2 h-12 w-12 text-yellow-500" />
                    <CardTitle>Pending Approval</CardTitle>
                </CardHeader>
                <CardContent>
                    <p className="text-muted-foreground mb-4">
                        Your membership is awaiting approval from an administrator.
                        You’ll be able to access the app once it’s approved.
                    </p>
                </CardContent>
            </Card>
        </MainLayout>
    );
}